


function initNewsletterModal() {
  	var hasDismissed = window.localStorage.getItem('dismissedNewsletter');
  if (hasDismissed) return;
var $newsletterModal = document.querySelector('.custom-modal-wrapper');
  var $closeBtn = document.querySelector('.custom-modal-wrapper .icon-close');
  var $closeLink = document.querySelector('.custom-modal-wrapper a.close');
  var $ctaBtn = document.querySelector('.custom-modal-wrapper .go-to-newsletter');
  
  var closeModal = function() {
  	$newsletterModal.classList.remove('active');
    window.localStorage.setItem('dismissedNewsletter', '1');
  }
  
  $ctaBtn.addEventListener('click', function(){
  	closeModal();
  });
  
  $closeBtn.addEventListener('click', function(){
   closeModal();
  });
  $closeLink.addEventListener('click', function(e){
    e.preventDefault();
   closeModal();
  });
  
  $newsletterModal.addEventListener('click', function(e){
    if (e.target === e.currentTarget) {
    	closeModal();
    }
  });
  
 
  
  window.setTimeout(function(){
  $newsletterModal.classList.add('active');
  }, 10000);
  	
}


document.addEventListener('DOMContentLoaded', function () {
  initNewsletterModal();
}, false);